import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../../Redux/store"
import { useLogin } from "../../../Hooks/useLogin";
import { ProfileType } from "../../../Types/General";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "../../../Routes/RouteUrls";

interface AccountCreatedProps {}
export const AccountCreated = (props: AccountCreatedProps) =>{
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const accountCreation = useAppSelector( state => state.AccountCreation)
    const { login, loginLoading } = useLogin(accountCreation.ProfileType!);
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClick = () =>{
       login({user_login: accountCreation.Email!, password: accountCreation.Password!})
    }
    /* ******************** Effects ******************** */
    useEffect(() => {
        // Redirect to signup if no account creation data
        if (!accountCreation.Email || !accountCreation.Password) {
            navigate(RouteUrls.SignUp);
        }
    }, []);
    /* ******************** JSX ******************** */
    return (
        <Grid
            item
            bgcolor={'green.50'}
            width={"100%"}
            height={"100%"}
            overflow={"hidden"}
            display={"grid"}
            gridTemplateRows={"repeat(2, min-content)"}
            justifyItems={"center"}
            paddingY={6}
        >
            <Grid item xs display={"grid"} gridTemplateColumns={"1fr"} gridTemplateRows={"repeat(3, min-content)"} justifyItems={"center"}>
                <Typography variant="lora-display-small" marginBottom={"12px"}>Create an account</Typography>
                <Typography variant="body-large" marginBottom={"20px"}>
                    Your {ProfileType[accountCreation.ProfileType!]} account has been created
                </Typography>
            </Grid>
            <Grid item xs="auto">
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        height: "fit-content"
                    }}
                >
                    <img src={"/rocket_launch.png"} width={"100px"} style={{marginBottom: "30px"}}/>
                    <Button 
                        variant="contained" 
                        size="large"
                        endIcon={ loginLoading ? <CircularProgress color="secondary" size={"18px"}/> :null}
                        onClick={handleClick}
                    >
                        Get started 
                        { 
                            loginLoading && '...'
                        }
                    </Button>
                </Box>
            </Grid>
        </Grid>
    )
}